export default Object.freeze({
  CES: 'CES',
  CSAT: 'CSAT',
  NPS: 'NPS'
});